import { BaseApi } from './base.api.js';

export class NotificationTemplateApi extends BaseApi {
    constructor(client, basePath = '/notification-template') {
        super(client, basePath);
    }

    async getVariableContract(params = {}) {
        return this.client.get(`${this.basePath}/variable-contract`, { params });
    }

    async preview(payload) {
        return this.client.post(`${this.basePath}/preview`, payload);
    }

    async testSend(payload) {
        return this.client.post(`${this.basePath}/test-send`, payload);
    }
}
